import React from "react";
import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, Mail, FileText, LogOut, ExternalLink } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { LOGO_URL } from "@/lib/brand";

const nav = [
  { to: "/admin/dashboard", label: "Dashboard", icon: LayoutDashboard },
  { to: "/admin/contacts", label: "Kontaktanfragen", icon: Mail },
  { to: "/admin/blog", label: "Blog", icon: FileText },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const onLogout = async () => {
    await logout();
    navigate("/admin/login", { replace: true });
  };

  return (
    <div className="min-h-screen bg-slate-50 font-body flex" data-testid="admin-layout">
      <aside className="w-64 bg-[#0A192F] text-slate-200 flex flex-col fixed h-full">
        <div className="p-6 border-b border-white/10">
          <Link to="/" className="inline-block" data-testid="admin-brand">
            <img src={LOGO_URL} alt="X10 Management" className="h-16 w-auto" />
          </Link>
        </div>

        <nav className="flex-1 p-4 space-y-1">
          {nav.map(({ to, label, icon: Icon }) => (
            <NavLink
              key={to}
              to={to}
              data-testid={`admin-nav-${label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                  isActive ? "bg-white text-[#0A192F]" : "text-slate-300 hover:bg-white/5 hover:text-white"
                }`
              }
            >
              <Icon size={18} />
              {label}
            </NavLink>
          ))}
        </nav>

        <div className="p-4 border-t border-white/10">
          <Link to="/" target="_blank" rel="noreferrer" className="flex items-center gap-2 px-4 py-2 text-xs uppercase tracking-[0.2em] text-slate-400 hover:text-white" data-testid="admin-view-site">
            <ExternalLink size={14} /> Website öffnen
          </Link>
          <div className="mt-4 p-3 bg-white/5 rounded-lg" data-testid="admin-user-card">
            <div className="text-sm font-semibold text-white truncate">{user?.name || "Admin"}</div>
            <div className="text-xs text-slate-400 truncate">{user?.email}</div>
            <button
              onClick={onLogout}
              data-testid="admin-logout"
              className="mt-3 w-full inline-flex items-center justify-center gap-2 px-3 py-2 bg-white/10 hover:bg-white/20 text-white text-xs font-semibold rounded-md transition-colors"
            >
              <LogOut size={14} /> Abmelden
            </button>
          </div>
        </div>
      </aside>

      <main className="ml-64 flex-1 min-h-screen">
        <div className="max-w-6xl mx-auto p-8 lg:p-12">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
